import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-faq-item',
  templateUrl: './faq-item.component.html',
  styleUrls: ['./faq-item.component.scss'],
  standalone: false
})

export class FaqItemComponent {
  @Input() public title: string = '';
  @Input() public text: string = '';
  @Input() public index: number = 0;

  private _plus: string = 'assets/images/PlusCircle.png';
  private _minus: string = 'assets/images/MinusCircle.png';
  public img: string = this._plus;

  public hideShow(item: string) {
    if (document.getElementById('faq' + item)?.classList.contains('hidden')) {
      document.getElementById('faq' + item)?.classList.remove('hidden');
      document.getElementById('img' + item)?.setAttribute('src', this._minus);
    } else {
      document.getElementById('faq' + item)?.classList.add('hidden');
      document.getElementById('img' + item)?.setAttribute('src', this._plus);
    }
  }
}
